import { useFeatureFlags } from '../../../hooks/useFeatureFlags';
import { getGravityUserOrgId } from '../../../hooks/useAuth';

/** Organization-scoped product UX rollout only; never grants data or Apply access. */
export function useAtlasUnifiedChanges(): boolean {
  const { flags, loading } = useFeatureFlags();
  return !loading && flags?.orgId === getGravityUserOrgId() && flags?.flags.ATLAS_UNIFIED_CHANGES === true;
}
